module.exports = __webpack_public_path__ + "static/media/step-indicator-1.2852c4d5.svg";